import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { isAuthenticated, startSessionMonitoring, stopSessionMonitoring } from '../../../utils/auth';
import * as authHandlers from '../../../routes/Auth/redux/handlers';

// Pathless route wrapper for auth pages
export const AuthRoute = () => {    
    useEffect(() => {
        stopSessionMonitoring();
    }, []);
    
    const isAuth = isAuthenticated();
    
    if (isAuth) {
        return <Navigate to="/admin/home" replace />;
    }
    
    return <Outlet />;
};

// Pathless route wrapper for protected pages
export const PrivateRoute = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user);
    const isAuth = isAuthenticated();
    
    useEffect(() => {
        if (isAuth) {
            startSessionMonitoring(async () => {
                await dispatch(authHandlers.logoutHandler());
                window.location.href = '/auth/login';
            });
            
            if (!user?.id) {
                dispatch(authHandlers.fetchUserHandler());
            }
        }
        
        return () => {
            stopSessionMonitoring();
        };
    }, [isAuth, user, dispatch]);
    
    if (!isAuth) {
        return <Navigate to="/auth/login" replace />;
    }
    
    return <Outlet />;
};

// Default route for undefined paths
export const DefaultRoute = () => {
    const isAuth = isAuthenticated();
    return <Navigate to={isAuth ? "/admin/home" : "/auth/login"} replace />;
};
